package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.components.WebPagination

@Composable
fun AdminPagination(
    currentPage: Int,
    totalPages: Int,
    totalCount: Long? = null,
    onPageChange: (Int) -> Unit,
) {
    WebPagination(
        currentPage = currentPage,
        totalPages = totalPages,
        totalCount = totalCount,
        onPageChange = onPageChange,
    )
}
